import React from "react"
import { PersianDatePicker } from "components/Common/PersianDatePicker"
import Locations from "components/Common/Locations"
import MapComp from "components/Common/MapComp"
import {
  Avatar,
  Card,
  Col,
  Collapse,
  Descriptions,
  Form,
  Input,
  Radio,
  Row,
  Space,
  Switch,
  Tag,
  Typography,
} from "antd"
import {
  AimOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  HomeOutlined,
  IdcardOutlined,
  NumberOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons"

const { Text } = Typography

const buildingTypes = {
  1: "مسکونی",
  2: "تجاری",
  3: "اداری",
  4: "صنعتی",
  5: "عمومی",
}

const buildingOptions = [
  { value: 1, label: "مسکونی", color: "#52c41a" },
  { value: 2, label: "تجاری", color: "#1677ff" },
  { value: 3, label: "اداری", color: "#722ed1" },
  { value: 5, label: "عمومی", color: "#13c2c2" },
  { value: 4, label: "صنعتی", color: "#fa541c" },
]

export default function ProjectDetailsMobile({
  formInput,
  handleInput,
  handleSelectChange,
  setIsErrorValid,
  matches_sm,
  userInfo,
  dataAddress,
  setDataAddress,
}) {
  return (
    <Space direction="vertical" size={12} style={{ width: "100%", paddingTop: 4 }}>
      <Card
        bordered={false}
        style={{
          borderRadius: 16,
          background: "linear-gradient(135deg, rgba(24,144,255,0.08), rgba(82,196,26,0.05))",
          boxShadow: "0 6px 20px rgba(15,23,42,0.05)",
        }}
        bodyStyle={{ padding: 14 }}
      >
        <Space direction="vertical" size={10} style={{ width: "100%" }}>
          <Space align="start" size={10}>
            <Avatar
              size={40}
              icon={<FileTextOutlined />}
              style={{ background: "linear-gradient(135deg, #1677ff, #13c2c2)" }}
            />
            <Space direction="vertical" size={0}>
              <Text strong style={{ fontSize: 15 }}>تکمیل اطلاعات پرونده</Text>
              <Text type="secondary" style={{ fontSize: 12 }}>
                نسخه موبایل برای ثبت سریع‌تر و خواناتر
              </Text>
            </Space>
          </Space>

          <Descriptions
            size="small"
            column={1}
            items={[
              {
                key: "ownership",
                label: "نوع مالکیت",
                children: (
                  <Tag color={formInput.ownershipTypeEnum === "2" ? "gold" : "blue"} style={{ borderRadius: 999 }}>
                    {formInput.ownershipTypeEnum === "2" ? "حقوقی" : "حقیقی"}
                  </Tag>
                ),
              },
              {
                key: "building",
                label: "کاربری",
                children: <Text>{buildingTypes[+formInput.buildingTypeEnum || 1]}</Text>,
              },
              {
                key: "pipe",
                label: "لوله‌کشی",
                children: (
                  <Tag color={+formInput.pipingTypeEnum === 1 ? "purple" : "green"} style={{ borderRadius: 999 }}>
                    {+formInput.pipingTypeEnum === 1 ? "توکار" : "روکار"}
                  </Tag>
                ),
              },
            ]}
          />
        </Space>
      </Card>

      <Collapse
        defaultActiveKey={["owner", "building", "location"]}
        size="small"
        ghost
        items={[
          {
            key: "owner",
            label: (
              <Space size={8}>
                <Avatar size={28} icon={<UserOutlined />} style={{ backgroundColor: "#1677ff" }} />
                <Text strong>مشخصات مالک</Text>
              </Space>
            ),
            children: (
              <Space direction="vertical" size={10} style={{ width: "100%" }}>
                <Form.Item label="نام و نام خانوادگی" style={{ margin: 0 }}>
                  <Input
                    prefix={<UserOutlined style={{ color: "#bbb" }} />}
                    required
                    name="landlordName"
                    value={formInput.landlordName}
                    onChange={handleInput}
                    placeholder="نام کامل مالک"
                    style={{ borderRadius: 10, height: 42 }}
                  />
                </Form.Item>

                <Form.Item
                  label="کدملی / شناسه ملی"
                  style={{ margin: 0 }}
                  validateStatus={formInput.landlordNaCode && formInput.landlordNaCode.length !== 10 ? "error" : ""}
                  help={
                    formInput.landlordNaCode && formInput.landlordNaCode.length !== 10
                      ? <Text type="danger" style={{ fontSize: 11 }}>باید دقیقاً ۱۰ رقم باشد</Text>
                      : <Text type="secondary" style={{ fontSize: 11 }}>۱۰ رقم</Text>
                  }
                >
                  <Input
                    prefix={<IdcardOutlined style={{ color: "#bbb" }} />}
                    required
                    name="landlordNaCode"
                    value={formInput.landlordNaCode}
                    type="number"
                    placeholder="0000000000"
                    onFocus={e => e.target.select()}
                    onChange={e => {
                      handleInput(e)
                      setIsErrorValid(e.target.value.length !== 10)
                    }}
                    style={{ borderRadius: 10, height: 42 }}
                  />
                </Form.Item>

                <Form.Item
                  label="شماره تماس"
                  style={{ margin: 0 }}
                  validateStatus={formInput.landlordPhoneNumber && formInput.landlordPhoneNumber.length !== 11 ? "error" : ""}
                  help={
                    formInput.landlordPhoneNumber && formInput.landlordPhoneNumber.length !== 11
                      ? <Text type="danger" style={{ fontSize: 11 }}>باید ۱۱ رقم باشد</Text>
                      : <Text type="secondary" style={{ fontSize: 11 }}>مثال: 09123456789</Text>
                  }
                >
                  <Input
                    prefix={<PhoneOutlined style={{ color: "#bbb" }} />}
                    required
                    name="landlordPhoneNumber"
                    value={formInput.landlordPhoneNumber}
                    dir="ltr"
                    placeholder="09xxxxxxxxx"
                    onFocus={e => e.target.select()}
                    onChange={e => {
                      handleInput(e)
                      setIsErrorValid(e.target.value.length !== 11)
                    }}
                    style={{ borderRadius: 10, height: 42 }}
                  />
                </Form.Item>

                <Form.Item label="شماره پرونده قبلی" style={{ margin: 0 }}>
                  <Input
                    name="des1"
                    value={formInput.des1}
                    onChange={handleInput}
                    placeholder="در صورت تمدید وارد کنید"
                    style={{ borderRadius: 10, height: 42 }}
                  />
                </Form.Item>
              </Space>
            ),
          },
          {
            key: "building",
            label: (
              <Space size={8}>
                <Avatar size={28} icon={<HomeOutlined />} style={{ backgroundColor: "#fa8c16" }} />
                <Text strong>مشخصات ساختمان</Text>
              </Space>
            ),
            children: (
              <Space direction="vertical" size={12} style={{ width: "100%" }}>
                <Form.Item label="نوع کاربری" style={{ margin: 0 }}>
                  <Radio.Group
                    value={+formInput.buildingTypeEnum || 1}
                    onChange={e => {
                      handleSelectChange("buildingTypeEnum", e.target.value)
                      if (![1, 2].includes(e.target.value) && +formInput.unitNumber > 1) {
                        handleInput({ target: { name: "unitNumber", value: 1 } })
                      }
                    }}
                    style={{ display: "flex", flexWrap: "wrap", gap: 8 }}
                  >
                    {buildingOptions.map(opt => (
                      <Radio.Button
                        key={opt.value}
                        value={opt.value}
                        style={{
                          borderRadius: 10,
                          fontSize: 12,
                          height: 32,
                          lineHeight: "30px",
                          border: +formInput.buildingTypeEnum === opt.value
                            ? `2px solid ${opt.color}`
                            : "1px solid #d9d9d9",
                          color: +formInput.buildingTypeEnum === opt.value ? opt.color : "inherit",
                          fontWeight: +formInput.buildingTypeEnum === opt.value ? 600 : 400,
                        }}
                      >
                        {opt.label}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                </Form.Item>

                <Form.Item label="نوع لوله‌کشی" style={{ margin: 0 }}>
                  <Radio.Group
                    name="pipingTypeEnum"
                    value={+formInput.pipingTypeEnum}
                    onChange={handleInput}
                    buttonStyle="solid"
                    style={{ display: "flex", width: "100%" }}
                  >
                    <Radio.Button value={0} style={{ flex: 1, textAlign: "center" }}>روکار</Radio.Button>
                    <Radio.Button value={1} style={{ flex: 1, textAlign: "center" }}>توکار</Radio.Button>
                  </Radio.Group>
                </Form.Item>

                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 14px",
                  borderRadius: 10,
                  border: formInput.hasBurial
                    ? "2px solid #722ed1"
                    : "1.5px solid #f0f0f0",
                  background: formInput.hasBurial
                    ? "rgba(114,46,209,0.06)"
                    : "#fafafa",
                  cursor: "pointer",
                  transition: "all 0.25s ease",
                }}
                  onClick={() => handleInput({ target: { name: "hasBurial", value: !formInput.hasBurial } })}
                >
                  <Space size={8}>
                    <span style={{ fontSize: 16 }}>⚰</span>
                    <div>
                      <Text strong style={{
                        fontSize: 13,
                        color: formInput.hasBurial ? "#722ed1" : "#333",
                        display: "block",
                      }}>دفن لوله</Text>
                      <Text type="secondary" style={{ fontSize: 11 }}>شامل عملیات دفن لوله</Text>
                    </div>
                  </Space>
                  <Switch
                    checked={!!formInput.hasBurial}
                    onChange={checked => handleInput({ target: { name: "hasBurial", value: checked } })}
                    style={{
                      backgroundColor: formInput.hasBurial ? "#722ed1" : undefined,
                    }}
                  />
                </div>

                <Row gutter={[10, 10]}>
                  <Col span={16}>
                    <Form.Item
                      label="کد پستی"
                      style={{ margin: 0 }}
                      validateStatus={formInput.postalCode && formInput.postalCode.length !== 10 ? "error" : ""}
                      help={<Text type="secondary" style={{ fontSize: 11 }}>۱۰ رقم</Text>}
                    >
                      <Input
                        prefix={<NumberOutlined style={{ color: "#bbb", fontSize: 11 }} />}
                        required
                        name="postalCode"
                        type="number"
                        value={formInput.postalCode}
                        onFocus={e => e.target.select()}
                        onChange={e => {
                          handleInput(e)
                          setIsErrorValid(e.target.value.length !== 10)
                        }}
                        style={{ borderRadius: 10, height: 42 }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label="تعداد واحد"
                      style={{ margin: 0 }}
                      help={
                        ![1, 2].includes(+formInput.buildingTypeEnum || 1)
                          ? <Text type="warning" style={{ fontSize: 10, color: '#fa8c16' }}>فقط مسکونی/تجاری</Text>
                          : null
                      }
                    >
                      <Input
                        required
                        name="unitNumber"
                        type="number"
                        min={1}
                        max={![1, 2].includes(+formInput.buildingTypeEnum || 1) ? 1 : undefined}
                        disabled={![1, 2].includes(+formInput.buildingTypeEnum || 1)}
                        value={![1, 2].includes(+formInput.buildingTypeEnum || 1) ? 1 : formInput.unitNumber}
                        onFocus={e => e.target.select()}
                        onChange={e => {
                          handleInput(e)
                          setIsErrorValid(+e.target.value <= 0)
                        }}
                        style={{ borderRadius: 10, height: 42, textAlign: "center" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="طبقه"
                      style={{ margin: 0 }}
                      help={<Text type="secondary" style={{ fontSize: 11 }}>{+formInput.unitNumber > 1 ? "چند واحدی → همکف" : "0 = همکف"}</Text>}
                    >
                      <Input
                        required
                        name="floorNumber"
                        type="number"
                        disabled={+formInput.unitNumber > 1 || +formInput.unitNumber <= 0}
                        value={+formInput.unitNumber === 1 ? formInput.floorNumber : "0"}
                        onFocus={e => e.target.select()}
                        onChange={handleInput}
                        style={{ borderRadius: 10, height: 42, textAlign: "center" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="شماره واحد" style={{ margin: 0 }}>
                      <Input
                        name="unitDes"
                        value={formInput.unitDes}
                        onChange={handleInput}
                        placeholder="مثلاً: ۱"
                        style={{ borderRadius: 10, height: 42, textAlign: "center" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="زیربنا (م²)" style={{ margin: 0 }}>
                      <Input
                        required
                        name="area"
                        type="number"
                        min={1}
                        value={formInput.area}
                        onFocus={e => e.target.select()}
                        onChange={e => {
                          handleInput(e)
                          setIsErrorValid(+e.target.value <= 0)
                        }}
                        style={{ borderRadius: 10, height: 42, textAlign: "center" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Space>
            ),
          },
          {
            key: "location",
            label: (
              <Space size={8}>
                <Avatar size={28} icon={<EnvironmentOutlined />} style={{ backgroundColor: "#52c41a" }} />
                <Text strong>موقعیت مکانی</Text>
              </Space>
            ),
            children: (
              <Space direction="vertical" size={12} style={{ width: "100%" }}>
                <Locations
                  setDataAddress={setDataAddress}
                  matches_sm={matches_sm}
                  isAccessCity={false}
                  idSection={userInfo && userInfo.idSection}
                />
                <MapComp
                  coords={dataAddress}
                  setDataAddress={setDataAddress}
                  mainAddress={formInput.fullAddress}
                  matches_sm={matches_sm}
                />
                <Card
                  size="small"
                  bordered={false}
                  style={{ borderRadius: 12, background: "rgba(255,255,255,0.95)" }}
                  bodyStyle={{ padding: 12 }}
                >
                  <Space direction="vertical" size={8} style={{ width: "100%" }}>
                    <Space size={6}>
                      <AimOutlined style={{ color: "#52c41a" }} />
                      <Text type="secondary" style={{ fontSize: 12 }}>عرض:</Text>
                      <Tag color="green" style={{ borderRadius: 6, fontVariantNumeric: "tabular-nums" }}>
                        {dataAddress.fullAddress.lat.toFixed(5)}
                      </Tag>
                    </Space>
                    <Space size={6}>
                      <AimOutlined style={{ color: "#1677ff" }} />
                      <Text type="secondary" style={{ fontSize: 12 }}>طول:</Text>
                      <Tag color="blue" style={{ borderRadius: 6, fontVariantNumeric: "tabular-nums" }}>
                        {dataAddress.fullAddress.lng.toFixed(5)}
                      </Tag>
                    </Space>
                  </Space>
                </Card>
              </Space>
            ),
          },
        ]}
      />
    </Space>
  )
}
